import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Modal,
  ThemeProvider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
// import { makeStyles } from "@mui/material/styles";

import CheckIcon from "@mui/icons-material/Check";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { basicTheme } from "../../themes/customTheme";
import Backdrop from "@mui/material/Backdrop";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import SnackBars from "../reusableComponents/SnackBar";
import BasicTextfield from "../reusableComponents/BasicTextfield";
import BasicDropDown from "../reusableComponents/BasicDropDown";
import AutoCompleteMultiDropdown from "./AutoCompleteMultiDropdown";
import { getFromData } from "../../features/formManagement/formManagementAPIs";
import BackDropLoader from "../reusableComponents/BackDropLoader";
import { editProjectData } from "../../features/projects/projectsAPIs";
import dayjs from "dayjs";
import AutoCompleteDropdown from "../reusableComponents/AutoCompleteDropDown";
import { getPartnerData } from "../../features/partner/partnerAPIs";

const subGridStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "1.5rem",
  width: "65%",
  maxHeight: "80%",
  overflow: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  paddingLeft: 5,
  paddingTop: 2,
};

// const useStyles = makeStyles(() => ({
//   closeBtnStyle: {
//     zoom: "2.2",
//     alignItems: "right",
//     color: "#444444",
//     cursor: "pointer",
//     "&:hover": { opacity: 0.7 },
//     maxHeight: "1rem",
//     maxWidth: "1rem",
//   },
//   textField: {
//     "& .MuiInputBase-input": {
//       border: "none", // Remove the border
//     },
//     "& .MuiInput-underline:before": {
//       border: "none", // Remove the underline
//     },
//     "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
//       border: "none", // Remove the underline on hover
//     },
//   },
// }));

const ButtonStyle = styled(Button)({
  backgroundColor: "#2D6A4F",
  color: "white",
  textTransform: "none",
  borderRadius: "1rem",
  fontSize: "16px",
  fontWeight: "600",
  minWidth: "140px",
  maxWidth: "150px",
  height: "54px",
});

const CancelButtonStyle = styled(Button)({
  backgroundColor: "white",
  color: "#2D6A4F",
  textTransform: "none",
  borderRadius: "1rem",
  fontSize: "16px",
  fontWeight: "600",
  minWidth: "140px",
  maxWidth: "150px",
  height: "54px",
});

export default function EditProjectModal({
  openEditModal,
  handleClose = () => {},
  data = null,
  setProjectSnackBarMessage = () => {},
  setProjectSnackBarType = () => {},
  setReload = () => {},
  setOpenSuccessBox = () => {},
  setSuccessMessage = () => {},
  setOpenSuccessBoxType = () => {},
}) {
  // const classes = useStyles();
  const dispatch = useDispatch();
  const [id, setId] = useState(data ? (data.id ? data.id : "") : "");
  const [projectName, setProjectName] = useState(
    data ? (data.name ? data.name : "") : ""
  );
  // const [projectStatus, setProjectStatus] = useState(
  //   data ? (data.is_active === true ? "Active" : "Inactive") : ""
  // );
  const [formIds, setFormIds] = useState(
    data ? (data.forms ? data.forms : []) : []
  );
  const [addPartnerSnackBar, setAddPartnerSnackBar] = useState(false);
  const [addPartnerSnackBarMessage, setAddPartnerSnackBarMessage] =
    useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const [startDate, setStartDate] = useState(data.start_date ? data.start_date : dayjs(new Date()));
  // const [formattedStartDate, setFormattedStartDate] = useState(
  //   dayjs(data.start_date ? data.start_date : new Date()).format("YYYY-MM-DD")
  // );
  // const [endDate, setEndDate] = useState(data.end_date ? data.end_date : dayjs(new Date()));
  // const [formattedEndDate, setFormattedEndDate] = useState(
  //   dayjs(data.end_date ? data.end_date : new Date()).format("YYYY-MM-DD")
  // );
  const [formIdList, setFormIdList] = useState([]);

  const basicError = {
    projectName: "",
    // projectForms: "",
    // formIds: [],
    farmerPartner: "",
  };
  const [snackBarType, setSnackBarType] = useState("success");
  const [errors, setErrors] = useState(basicError);

  // const projectStatusList = ["Active", "Inactive"];
  const [loading, setLoading] = useState(false);
  const [partnerDataResponse, setPartnerDataResponse] = useState(
    data.users || []
  );
  // const [partnerNamesData, setPartnerNamesData] = useState(data.userArray.map((item) => ({
  //   id: item.id,
  //   name: item.user.username,
  // })) || []);
  const [partnerNamesData, setPartnerNamesData] = useState([]);
  const [farmerPartner, setFarmerPartner] = useState(
    data.userArray.map((item) => ({
      id: item.id,
      name: item.user.username,
    })) || []
  );
  // const [partnerDataResponse, setPartnerDataResponse] = useState([]);
  // const [partnerNamesData, setPartnerNamesData] = useState([]);
  // const [farmerPartner, setFarmerPartner] = useState(data.partner);

  const loggedInUser = JSON.parse(window.localStorage.getItem("loggedInUser"));

  const validateProjectFormData = () => {

    let projectNameError="";
    let farmerPartnerError="";

    if (projectName.trim() === "") {
      projectNameError = "Project Name can't be empty";
    }

    if (farmerPartner === null || farmerPartner === undefined) {

      farmerPartnerError = "Users can't be empty"
    }
    setErrors({
      ...errors,
      projectName: projectNameError,
      farmerPartner: farmerPartnerError,
    });
  };

  const handleChangeProjectName = (value) => {
    // value = value.trim(); // Trim leading and trailing spaces

    if (value === "") {
      setErrors({ ...errors, projectName: "Project Name can't be empty" });
    } else {
      setErrors({ ...errors, projectName: "" });
    }
    setProjectName(value);
  };

  // const handleChangeProjectStatus = (event) => {
  //   setProjectStatus(event.target.value);
  // };

  const handleChangeProjectFrom = (value) => {
    setFormIds(value);
    setErrors({ ...errors, projectForms: "" });
  };

  const handleChangeFarmerPartner = (value) => {
    setFarmerPartner(value);
    setErrors({ ...errors, farmerPartner: "" });
  };

  // const onStartDateChange = (newValue) => {
  //   var formattedDate = dayjs(newValue).format("YYYY-MM-DD");
  //   setFormattedStartDate(formattedDate);
  //   setStartDate(newValue);
  //   setEndDate(newValue);
  // };
  // const onEndDateChange = (newValue) => {
  //   var formattedDate = dayjs(newValue).format("YYYY-MM-DD");
  //   setFormattedEndDate(formattedDate);
  //   setEndDate(newValue);
  // };

  // useEffect(async () => {
  //   try {
  //     const response = await getFromData({ fields: ["id", "name"] })
  //     setFormIdList(response.data['data'])
  //   }
  //   catch {
  //     setSnackBarType("error");
  //     setAddPartnerSnackBar(true);
  //     setAddPartnerSnackBarMessage('Error while getting form list'); // Use error.response.data here
  //   }
  // }, [])

  const handleCloseByClearIcon = () => {
    setErrors(basicError);
    setProjectName("");
    // setProjectStatus("");
    //setFormIds([]);
    setAddPartnerSnackBar(false);
    setSnackBarType("success");
    setAddPartnerSnackBarMessage("");
    setProjectSnackBarType("");
    setProjectSnackBarMessage("");
    handleClose();
  };

  const handleSaveData = async () => {
    if (
      errors.projectName === "" &&
      errors.farmerPartner === "" &&
      // projectStatus !== "" &&
      projectName !== ""
    ) {
      const userIdArray = farmerPartner.map((user) => user.id);
      const data = {
        name: projectName,
        users: userIdArray,
        // ...(userIdArray.length > 0 && { users: userIdArray })
      };
      try {
        setLoading(true);
        const response = await editProjectData(data, id);
        setOpenSuccessBox(true);
        setSuccessMessage("Project successfully updated.");
        setOpenSuccessBoxType("success");
        setReload(true);
        setLoading(false);
        handleClose();
      } catch (error) {
        setLoading(false);
        setOpenSuccessBox(true);
        setSuccessMessage(error.response.data);
        setOpenSuccessBoxType("error");
        console.error("API Error:", error.message); // Log the error message
      }
    } else {
      validateProjectFormData();
      setOpenSuccessBox(true);
      setSuccessMessage("Please fill all the required fields");
      setOpenSuccessBoxType("error");
    }
  };

  const getPartnerList = async () => {
    setLoading(true);
    try {
      const response = await getPartnerData({ all: "true" });
      setPartnerDataResponse(response.data);
      const partnerNamesList = response.data.map((item) => ({
        id: item.id,
        name: item.user.username,
      }));
      setPartnerNamesData(partnerNamesList);
      setLoading(false);
    } catch (error) {
      setSnackBarType("error");
      setAddPartnerSnackBar(true);
      setAddPartnerSnackBarMessage("Error while getting user list");
    }
  };

  return (
    <Modal open={openEditModal}>
      <Grid container sx={subGridStyle} spacing={1}>
        <ThemeProvider theme={basicTheme}>
          <Grid item xs={11} marginY={1.5}>
            <Typography
              variant="h4"
              sx={{ color: "#444444", fontWeight: "500" }}
            >
              Edit Project
            </Typography>
          </Grid>
          <Grid
            item
            xs={1}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <CloseRoundedIcon
              // className={classes.closeBtnStyle}
              onClick={handleCloseByClearIcon}
            />
          </Grid>
          <Grid container item spacing={2} xs={12} sx={{ width: "90%" }}>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{ marginBottom: 1, fontFamily: "Inter", color: "#444444" }}
              >
                Project Name
              </Typography>
              <BasicTextfield
                label="Enter Project Name"
                is_phone={false}
                handleChange={handleChangeProjectName}
                is_disabled={false}
                index={1}
                error={errors.projectName !== ""}
                helperText={errors.projectName}
                required={true}
                value={projectName}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <Typography
                sx={{ marginBottom: 1, fontFamily: "Inter", color: "#444444" }}
              >
                Project Status
              </Typography>
              <BasicDropDown
                text="Select Project Status"
                value={projectStatus}
                handleChange={handleChangeProjectStatus}
                menuList={projectStatusList}
                error={false}
                required={true}
              />
            </Grid> */}
            {/* <Grid item xs={12} sm={6}>
              <Typography sx={{ marginBottom: 1 }}>Project Start Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  inputFormat="DD/MM/YYYY"
                  value={startDate}
                  minDate={dayjs()}
                  onChange={onStartDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      onKeyDown={(e) => e.preventDefault()}
                      sx={{
                        marginBottom: 1,
                        borderRadius: "1rem",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "1rem", // Change the border radius of the outline
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "1rem", // Change the border radius on hover
                        },
                        width: "90%",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid> */}
            {/* <Grid item xs={12} sm={6}>
              <Typography sx={{ marginBottom: 1 }}>Project End Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  inputFormat="DD/MM/YYYY"
                  value={endDate}
                  minDate={startDate}
                  onChange={onEndDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      onKeyDown={(e) => e.preventDefault()}
                      sx={{
                        marginBottom: 1,
                        borderRadius: "1rem",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "1rem", // Change the border radius of the outline
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "1rem", // Change the border radius on hover
                        },
                        width: "90%",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid> */}
            {/* <Grid item xs={12} sm={6}>
              <Typography sx={{ marginBottom: 1 }}>Forms</Typography>
              <AutoCompleteMultiDropdown
                width={230}
                menuList={formIdList}
                selectedOptions={formIds}
                onHighlightChange={(value) => { handleChangeProjectFrom(value) }}
                label="Select Forms"
                // disable={disable || getForms.length === 0}
                required={true}
                error={errors.projectForms !== ""}
                errorText={errors.projectForms}
              />
            </Grid> */}
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{
                  marginBottom: 1,
                }}
              >
                Users
              </Typography>
              <AutoCompleteMultiDropdown
                width="auto"
                menuList={partnerNamesData}
                selectedOptions={farmerPartner}
                setSelectedOptions={handleChangeFarmerPartner}
                label="Select User(s)"
                required={true}
                onOpen={getPartnerList}
                loading={loading}
                error={errors.farmerPartner !== ""}
                errorText={errors.farmerPartner}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              item
              sm={12}
              spacing={0}
              sx={{
                direction: "row",
                justifyContent: "center",
                marginTop: 5,
                marginBottom: 5,
              }}
            >
              <Grid
                item
                xs={12}
                sm={2.5}
                style={{ backgroundColor: "transparent", boxShadow: "none" }}
              >
                <CancelButtonStyle
                  variant="contained"
                  name="cancel"
                  onClick={handleClose}
                >
                  Cancel
                </CancelButtonStyle>
              </Grid>
              <Grid item xs={12} sm={2.5}>
                <ButtonStyle
                  variant="contained"
                  name="add"
                  startIcon={<CheckIcon size="large" />}
                  onClick={handleSaveData}
                >
                  Save
                </ButtonStyle>
              </Grid>
            </Grid>
            <div style={{ willChange: "transform" }}>
              {addPartnerSnackBar && (
                <SnackBars
                  open={addPartnerSnackBar}
                  handleClose={() => setAddPartnerSnackBar(false)}
                  severity={snackBarType}
                  message={addPartnerSnackBarMessage}
                  autoHideDuration={6000}
                  vertical="bottom"
                  horizontal="center"
                />
              )}
            </div>
          </Grid>
          <BackDropLoader loading={loading} />
          <BackDropLoader loading={isLoading} />
        </ThemeProvider>
      </Grid>
    </Modal>
  );
}
